import { Theme } from '@shipengine/giger-theme';
import { css, SerializedStyles } from '@emotion/react';

export const getImageUploaderStyles = (): SerializedStyles =>
    css({
        img: {
            maxHeight: 110,
            maxWidth: 270,
        },
    });

export const getTitleStyles = (theme: Theme): SerializedStyles =>
    css({
        marginBottom: theme.spacing(3 / 2),
    });

export const getSubtitleStyles = (theme: Theme): SerializedStyles =>
    css({
        margin: `${theme.spacing()}px 0 ${theme.spacing(1)}px 0`,
    });

export const getFieldStyles = (): SerializedStyles =>
    css({
        maxWidth: 334,
    });

export const getDisabledFieldSetStyles = (theme: Theme): SerializedStyles =>
    css({
        background: theme.palette.gray[100],
        border: 'none',
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(6),
        opacity: 0.7,
    });
